import { FaCheck } from "react-icons/fa6";

export function SelectItem({
    value,
    label,
    currentlySelected,
    handleSelect,
}: {
    value: string | undefined;
    label: string | undefined;
    currentlySelected: string | undefined;
    handleSelect: (selection: string) => void;
}) {
    return (
        <li className="flex gap-2">
            <a onClick={() => handleSelect(value ?? "")}>
                {value == currentlySelected ? (
                    <FaCheck className="w-3 h-3 text-gray-400" />
                ) : (
                    <div className="w-3 h-3" />
                )}
                {label}
            </a>
        </li>
    );
}
